// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsuranceOutlinedSvg from "@ant-design/icons-svg/es/asn/InsuranceOutlined";
import AntdIcon from '../components/AntdIcon';

var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceOutlinedSvg
  }));
};

InsuranceOutlined.displayName = 'InsuranceOutlined';
export default React.forwardRef(InsuranceOutlined);